import { useContext } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { faGithubSquare } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mantine/core";

import { SimpleExternalLink } from "@components";

import { WorkbenchContext } from "@pages/editor/providers";

const TitleDiv = styled.div`
  display: flex;
  gap: 8px;
  font-size: var(--global-font-size-m);
  overflow-x: hidden;
  /* shrink more than other texts in the header */
  flex-shrink: 4;
  position: relative;
`;

const TitleText = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const sourceUriToHistory = (sourceUri: string | undefined) => {
  if (!sourceUri || !sourceUri.startsWith("https://github.com"))
    return undefined;
  return sourceUri.replace("blob", "commits");
};

const Title = () => {
  const { workbench } = useContext(WorkbenchContext);
  const { bundle } = workbench;

  const gitHistoryLink = sourceUriToHistory(
    workbench.remoteBundle?.displayProps.sourceUri
  );

  return (
    <TitleDiv>
      <Tooltip
        position="right-start"
        withArrow
        withinPortal
        label={
          <>
            To change the name, edit the <code>id</code> key in the editor:
            <br />
            <code>id: {bundle?.rule?.id ?? "<add rule id here>"}</code>
          </>
        }
      >
        <TitleText>
          {bundle === null ? "loading loading loading" : bundle.lastTitle}
        </TitleText>
      </Tooltip>
      {gitHistoryLink && (
        <SimpleExternalLink
          // align icon to text
          style={{ marginTop: "6px" }}
          href={gitHistoryLink}
        >
          <FontAwesomeIcon icon={faGithubSquare} />
        </SimpleExternalLink>
      )}
    </TitleDiv>
  );
};

export const EditorTitle = observer(Title);
